"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaContact = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const tpa_entity_1 = require("./tpa.entity");
const contact_entity_1 = require("./contact.entity");
let TpaContact = class TpaContact {
};
exports.TpaContact = TpaContact;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id" }),
    tslib_1.__metadata("design:type", Number)
], TpaContact.prototype, "tpaContactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "tpa_id" }),
    tslib_1.__metadata("design:type", Number)
], TpaContact.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Number)
], TpaContact.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => tpa_entity_1.Tpa, (tpa) => tpa.contacts),
    (0, typeorm_1.JoinColumn)({ name: "tpa_id" }),
    tslib_1.__metadata("design:type", Object)
], TpaContact.prototype, "tpa", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => contact_entity_1.Contact, (contact) => contact.tpaContacts, { eager: true }),
    (0, typeorm_1.JoinColumn)({ name: "contact_id" }),
    tslib_1.__metadata("design:type", Object)
], TpaContact.prototype, "linkedContact", void 0);
exports.TpaContact = TpaContact = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "tpa_contact" })
], TpaContact);
